import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Layout, Menu, Icon, Popover } from 'antd';
import IconFont from '../common/iconfont';
const { Header, Footer, Sider, Content } = Layout;
const { SubMenu } = Menu;

import Utils from '../../script/utils';
import MonitorTreeComp from '../../../windows/resourceMonitor/monitorTreeComp';
import * as settingActions from '../../actions/setting_action';
class AppSubSideMenu extends Component {
  constructor(props, context) {
    super(props, context);
    console.log("context",this.context)
    console.log("props",this.props)
  }
  state={
    selectedKey: '0',
    openKeys: []
  }
  componentDidMount(){
    this.getOpenKey(this.props.submenuType);
  }
  componentWillReceiveProps(nextProp) {
    if (nextProp.submenuType && nextProp.submenuType !== this.props.submenuType) {
      this.getOpenKey(nextProp.submenuType);
    }
  }

  getOpenKey(submenuType) {
    if (['userManage','roleManage','groupManage'].indexOf(submenuType) > -1) {
      var openKeys = this.state.openKeys;
      var openKey = 'userRoleManage';
      var flag = false;
      for (var i = 0; i < openKeys.length; i++) {
        if (openKeys[i] == openKey) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        openKeys.push(openKey);
        this.setState({ openKeys });
      }
    }
    else if (['monitorBatchAdd', 'monitorBatchDel', 'monitorBatchSetting', 'resourceBatchSetting', 'taskPlan'].indexOf(submenuType) > -1) {
      var openKeys = this.state.openKeys;
      var openKey = 'resourceMonitorSetting';
      var flag = false;
      for (var i = 0; i < openKeys.length; i++) {
        if (openKeys[i] == openKey) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        openKeys.push(openKey);
        this.setState({ openKeys });
      }
    }
    else if (['dataSourceConfigure','databaseUpdate','databaseBackup','databaseLogManage'].indexOf(submenuType) > -1) {
      var openKeys = this.state.openKeys;
      var openKey = 'dataManage';
      var flag = false;
      for (var i = 0; i < openKeys.length; i++) {
        if (openKeys[i] == openKey) {
          flag = true;
          break;
        }
      }
      if (!flag) {
        openKeys.push(openKey);
        this.setState({ openKeys });
      }
    }
  }
  onOpenChange = (openKeys) => {
    this.setState({ openKeys });
  }

  menuClick = (el) => {
    const {menuType} = this.props;
    console.log(this.props,789789)
    if (el.key && el.key.indexOf('#') == -1) {
      console.log(this)
      console.log(el.key)
      // if (menuType != 'setting') {
        // this.context.router.push("/" + el.key);
        this.props.history.push("/" + el.key);
      // }
      // else {
      //   this.props.settingActions.setSettingViewType(el.key);
      //   let settingViewTypes = ['userManage', 'roleManage', 'systemDetection'];
      //   if (settingViewTypes.indexOf(el.key) > -1) {
      //     this.props.settingActions.setSubmenuSettingViewType(el.key);
      //   }
      // }
    }
  }

  onCollapse = () => {
    this.setState({subSideCollapsed: !this.state.subSideCollapsed});
  }

  getMenuList = (menuType) => {
    menuType = menuType || this.props.menuType;
    let data = null;
    let menu = null, isTree = true;
    if (menuType == 'alarm') {
      data = [
        {key: 'alarmEvent', icon: 'icon-yichangshijianliebiaocopy', label: '报警事件', hasPermission: Utils.hasPermission('alarmEvent', '')},
        {key: 'alarmRule', icon: 'icon-baojingshezhi', label: '报警规则', hasPermission: Utils.hasPermission('alarmRule', '')},
        {key: 'sendSetting', icon: 'icon-send', label: '发送设置', hasPermission: Utils.hasPermission('sendSetup', '')},
        {key: 'alarmLog', icon: 'icon-logs', label: '发送日志', hasPermission: Utils.hasPermission('sendLog', '')}
      ];
      menu = this.getMenuTemplate(data);
      isTree = false;
    } else if (menuType == 'home') {
      isTree = true;
      menu = <div className="cell side" style={{height:'100%'}}><MonitorTreeComp ref={inst => this.treeComp = inst} /></div>;
    } else if (menuType == 'setting') {
      data = [
        {key: 'userRoleManage', icon: 'icon-Usermanagement', label: '用户角色管理', hasPermission: Utils.hasPermission('userrole', '') && (Utils.hasPermission('user', '') || Utils.hasPermission('role', '') || Utils.hasPermission('team', '')), children: [
          {key: 'userManage', icon: 'icon-users', label: '用户管理', hasPermission: Utils.hasPermission('user', '')},
          {key: 'roleManage', icon: 'icon-user-key', label: '角色和权限管理', hasPermission: Utils.hasPermission('role', '')},
          {key: 'groupManage', icon: 'icon-team_management', label: '运维团队管理', hasPermission: Utils.hasPermission('team', '')}
        ]},
        {key:'resourceMonitorSetting', icon: 'icon-banshou_Line', label: '资源监测设置', hasPermission: Utils.hasPermission('systemResource', ''), children: [
          // {key:'monitorBatchAdd', icon: 'icon-piliangtianjia', label: '监测器批量添加'},
          {key:'monitorBatchDel', icon: 'icon-piliangshanchu', label: '监测器批量删除', hasPermission: Utils.hasPermission('systemResource', 'monitorbatchdelete')},
          {key:'monitorBatchSetting', icon: 'icon-piliangshezhiquanxian', label: '监测器批量设置', hasPermission: Utils.hasPermission('systemResource', 'monitorbatchsetup')},
          {key:'resourceBatchSetting', icon: 'icon-piliangguanli', label: '资源批量设置', hasPermission: Utils.hasPermission('systemResource', 'resourcesbatchsetup')},
          {key:'taskPlan', icon: 'icon-daibanshixiang', label: '任务计划', hasPermission: Utils.hasPermission('taskplan', '')}
        ]},
        {key: 'dataManage', icon: 'icon-datdatabasecom1', label: '数据管理', hasPermission: Utils.hasPermission('systemDatabase', ''), children: [
          // {key: 'dataSourceConfigure', icon: 'icon-datdatabaseco4', label: '数据源配置', hasPermission: Utils.hasPermission('systemDatasource', '')},
          {key: 'databaseUpdate', icon: 'icon-datdatabaseco', label: '数据库更新', hasPermission: Utils.hasPermission('systemDatabaseUpdate', '')},
          // {key: 'databaseBackup', icon: 'icon-datdatabaseco1', label: '数据库备份', children: [
          //   {key: 'backupNow', icon: 'icon-save', label: '马上备份'},
          //   {key: 'backuptiming', icon: 'icon-calendar', label: '定时备份'}
          // ]},
          {key: 'databaseBackup', icon: 'icon-datdatabaseco1', label: '数据库备份', hasPermission: Utils.hasPermission('systemDatabaseBackup', '')},
          // {key: 'databaseLogManage', icon: 'icon-datdatabaseco2', label: '数据库日志管理', children: [
          //   {key: 'syncLog', icon: 'icon-datdatabasecom', label: '同步日志到数据库'},
          //   {key: 'ElasticSearchDataClean', icon: 'icon-datdatabaseco3', label: 'ElasticSearch数据清理'}
          // ]},
          {key: 'databaseLogManage', icon: 'icon-datdatabaseco2', label: '数据库日志管理', hasPermission: Utils.hasPermission('systemDatabaseLog', '')},
        ]},
        {key: 'systemRuntimeManage', icon: 'icon-nav-system-settings', label: '系统运行时管理', hasPermission: Utils.hasPermission('systemRunning', '')},
        {key: 'systemDetection', icon: 'icon-detection', label: '系统检测', hasPermission: Utils.hasPermission('system', 'selfcheck')},
        {key: 'operationalAudit', icon: 'icon-daibanshixiang', label: '操作审计', hasPermission: Utils.hasPermission('system', 'operationaudit')},
        // {key: 'softwareLicense', icon: 'icon-lock-off', label: '软件许可', hasPermission: Utils.hasPermission('system', 'license')},
        {key: 'resourceImages', icon: 'icon-images', label: '资源图标库', hasPermission: Utils.hasPermission('systemImage', '')},
        {key: 'equipmentInfoMaintenance', icon: 'icon-xinxi', label: '设备信息维护', hasPermission: Utils.hasPermission('systemMaintenance', '')},
        // {key: 'toolbox', icon: 'icon-tool_box', label: '工具箱', children: [
        //   {key: 'ipAccessLimit', icon: 'icon-limitip', label: 'IP访问限制'},
        //   {key: 'busObjectMaintain', icon: 'icon-relationship', label: '业务对象维护'},
        //   {key: 'importData', icon: 'icon-import', label: 'Excel导入数据'}
        // ]},
      ]
      menu = this.getMenuTemplate(data);
      isTree = false;
    } else if (menuType == 'report') {
      data = [
        {key: 'trendReport', icon: 'icon-baobiao2', label: '趋势报表', hasPermission: Utils.hasPermission('report', 'trend')},
        {key: 'stateStatisticsReport', icon: 'icon-baobiaofenxi', label: '状态统计报表', hasPermission: Utils.hasPermission('report', 'status')},
        {key: 'compareReport', icon: 'icon-baobiaobiaoweiguanli', label: '对比报表', hasPermission: Utils.hasPermission('report', 'contrast')},
        {key: 'topNReport', icon: 'icon-icon', label: 'TopN报表', hasPermission: Utils.hasPermission('report', 'topn')},
        {key: 'checkErrorReport', icon: 'icon-baobiao1', label: '巡检错误报表', hasPermission: Utils.hasPermission('report', 'error')},
        {key: 'checkStatisticsReport', icon: 'icon-baobiao', label: '巡检统计报表', hasPermission: Utils.hasPermission('report', 'statistics')},
        {key: 'checkLogSearch', icon: 'icon-baobiaoguanli', label: '巡检日志查询', hasPermission: Utils.hasPermission('report', 'select')}
      ];
      menu = this.getMenuTemplate(data);
      isTree = false;
    } else if (menuType == 'ems'){
      // isTree = false;
    }
    return { data, menu, isTree };
  }

  getMenuTemplate = (menus) => {
    return (
      <Menu
        mode="inline"
        defaultSelectedKeys={['home']}
        openKeys={this.state.openKeys}
        selectedKeys={[this.props.submenuType]}
        style={{ height: '100%', borderRight: 0 }}
        onClick={this.menuClick}
        onOpenChange={this.onOpenChange}
      >
        {menus.map((item, i) => {
          if (item.hasOwnProperty('children') && (!item.hasOwnProperty('hasPermission') || (item.hasOwnProperty('hasPermission') && item.hasPermission))) {
            return (
              <SubMenu key={item.key} title={<span><IconFont type={item.icon} /><span>{item.label}</span></span>}>
                  {item.children.map(child => {
                    if(child.hasOwnProperty('children') && (!child.hasOwnProperty('hasPermission') || (child.hasOwnProperty('hasPermission') && child.hasPermission))){
                      return (
                        <SubMenu key={child.key} title={<span><IconFont type={child.icon} /><span>{child.label}</span></span>}>
                          {child.children.map(child2 => {
                              return <Menu.Item key={child2.key}><IconFont type={child2.icon} /> <span>{child2.label}</span></Menu.Item>;
                          })}
                        </SubMenu>
                      )
                    }else{
                      return !child.hasOwnProperty('hasPermission') || (child.hasOwnProperty('hasPermission') && child.hasPermission) ? <Menu.Item key={child.key}><IconFont type={child.icon} /> <span>{child.label}</span></Menu.Item> : null;
                    }
                  })}
                </SubMenu>
            )
          } else {
            return !item.hasOwnProperty('hasPermission') || (item.hasOwnProperty('hasPermission') && item.hasPermission) ? <Menu.Item key={item.key}><IconFont type={item.icon} /> <span>{item.label}</span></Menu.Item> : null;
            // return <Menu.Item key={item.key}><IconFont type={item.icon} /> <span>{item.label}</span></Menu.Item>;
          }
        })}
      </Menu>
    )
  }

  render(){
    const {selectedKey} = this.state;
    const { subSideCollapsed, menuType, submenuType, sideCollapsed,isClosed } = this.props;
    const { menu, isTree } = this.getMenuList();
    // console.log(subSideCollapsed)
    return (
      <Sider
        // className="left-sub-menu"
        className={'left-sub-menu' + (!subSideCollapsed ? ' menu-scroll' : '') + (!sideCollapsed ? ' menu-scroll-l' : '')}
        style={{
          display: menu?"block":"none",
          background: '#fff',
          height: 'calc(100vh - 56px)',
          position: 'absolute',
          // left: 50,
          left: sideCollapsed ? 50:200,
          top:0,
          // borderRight: isTree ? '1px solid #e8e8e8' : '',
          borderLeft: '1px solid #e8e8e8',
        }}
        collapsible
        collapsed={subSideCollapsed}
        collapsedWidth={0}
        trigger={null}
        onCollapse={this.props.toggleSubSideCollapsed}>
        <div style={{position: 'relative', height:'100%', background: '#fff', overflow: isTree?'hidden':'auto'}}>
          {menu}
        </div>
        <Popover overlayClassName="custom-popover" placement="top" content={(subSideCollapsed?"展开":"收起") + (isTree?"IT资源树":"二级菜单")} mouseEnterDelay={0.5}>
          <div className={'toggleIcon'} style={{bottom:isClosed?'10px':'50px'}} onClick={this.props.toggleSubSideCollapsed}>
            <IconFont type={subSideCollapsed?"icon-preview-right":"icon-preview-left"} />
          </div>
        </Popover>
      </Sider>
    )
  }
}

// AppSubSideMenu.contextTypes = {
//   router: PropTypes.object
// }

// export default AppSubSideMenu;
const mapStateToProps = (state) => {
  let {isClosed}=state.closeReducer
  return {
    isClosed
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    settingActions: bindActionCreators(settingActions, dispatch)
  }
}
export default (connect(
  mapStateToProps,
  mapDispatchToProps, null, { forwardRef: true }
)((AppSubSideMenu)))
